import React, { useEffect } from 'react';
import MainLayout from '../../Layout/MainLayout';
import styles from './ProductPage.module.css'; // Import module-specific styles
import logo1 from '../../Assets/Home/Logo 1.png'; // Import asset images
import logo2 from '../../Assets/Home/Logo 2.png';
import logo3 from '../../Assets/Home/Logo 3.png';
import logo4 from '../../Assets/Home/Logo 4.png';
import logo5 from '../../Assets/Home/Logo 5.png';
import image1 from '../../Assets/Product/Image1.png';
import icon1 from '../../Assets/Product/Icon1.svg';
import icon2 from '../../Assets/Product/Icon2.svg';
import icon3 from '../../Assets/Product/Icon3.svg';
import icon4 from '../../Assets/Product/Icon4.svg';
import icon5 from '../../Assets/Product/Icon5.svg';
import icon6 from '../../Assets/Product/Icon6.svg';
import background2 from '../../Assets/Product/Backround2.png';
import image2 from '../../Assets/Product/Image2.png';
import image3 from '../../Assets/Product/Image3.png';
import image4 from '../../Assets/Product/Image4.png';
import icon7 from '../../Assets/Home/Icon 4.svg';
import icon8 from '../../Assets/Home/Icon 5.svg';
import icon9 from '../../Assets/Home/Icon 6.svg';
import { Link } from 'react-router-dom';

const ProductPage = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainLayout> {/* Wrapper component for main layout structure */}
      <div className={styles.product}>
        {/* Section 1 */}
        <div className={styles.product1}>
          <div className={styles.product1Top}>
            <div className={styles.product1TLeft}>
              <h1>Grow your Sales and Services</h1>
              <p className="pLarge">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              <div className={styles.product1TLButtons}>
                <Link to="/pricing">
                  <button>Get Started</button>
                </Link>
                <Link to="/contact">
                  <button className={styles.product1Button}>Contact us</button>
                </Link>
              </div>
            </div>
            <img src={image1} alt="Product" />
          </div>
          <div className={styles.product1Bottom}>
            <img src={logo1} alt="Logo" />
            <img src={logo2} alt="Logo" />
            <img src={logo3} alt="Logo" />
            <img src={logo4} alt="Logo" />
            <img src={logo5} alt="Logo" />
          </div>
        </div>

        {/* Section 2 */}
        <div className={styles.product2}>
          <div className={styles.product2Top}>
            <h2>Get the best out of your company with our service</h2>
          </div>
          <div className={styles.product2Bottom}>
            <div className={styles.product2BRow}>
              <div className={styles.product2BItem}>
                <img src={icon1} alt="Icon" />
                <h4>Security and privacy</h4>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
              </div>
              <div className={styles.product2BItem}>
                <img src={icon2} alt="Icon" />
                <h4>Built-in AI features</h4>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
              </div>
              <div className={styles.product2BItem}>
                <img src={icon3} alt="Icon" />
                <h4>Collaborate with others</h4>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
              </div>
            </div>
            <div className={styles.product2BRow}>
              <div className={styles.product2BItem}>
                <img src={icon4} alt="Icon" />
                <h4>Real time sync</h4>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
              </div>
              <div className={styles.product2BItem}>
                <img src={icon5} alt="Icon" />
                <h4>Built-in AI features</h4>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
              </div>
              <div className={styles.product2BItem}>
                <img src={icon6} alt="Icon" />
                <h4>Easy notes organization</h4>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 3 */}
        <div>
          <img className={styles.product3Back} src={background2} alt="Blur" />
          <div className={styles.productMiddle}>
            <div className={styles.productMiddleSide}>
              <h4>Marketing insights</h4>
              <h2>Data-driven client feedback</h2>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren.</p>
            </div>
            <img src={image2} alt="Diagram" />
          </div>
        </div>

        {/* Section 4 */}
        <div className={styles.productMiddle}>
          <img src={image3} alt="Diagram" style={{ width: 576 }} />
          <div className={styles.productMiddleSide}>
            <h4>Time tracker</h4>
            <h2>Track your project performance</h2>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren.</p>
          </div>
        </div>

        {/* Section 5 */}
        <div className={styles.product4}>
          <div className={styles.productMiddleSide}>
            <h4>Lead Generation</h4>
            <h2>More leads that convert</h2>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren.</p>
          </div>
          <img src={image4} alt="Diagram" style={{ width: 576 }} />
        </div>

        {/* Section 6 */}
        <div className={styles.productMiddle}>
          <img src={image3} alt="Diagram" style={{ width: 576 }} />
          <div className={styles.productMiddleSide}>
            <h4>Remote teams</h4>
            <h2>Real-time collaboration</h2>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren.</p>
          </div>
        </div>

        {/* Section 7 */}
        <div className={styles.product5}>
          <h2>Features</h2>
          <div className={styles.product5Bottom}>
            <div className={styles.product5BItem}>
              <img src={icon7} alt="Icon" />
              <h3>Advanced 256-bit encryption</h3>
              <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
            </div>
            <div className={styles.product5BItem}>
              <img src={icon8} alt="Icon" />
              <h3>Simple collaboration tools</h3>
              <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
            </div>
            <div className={styles.product5BItem}>
              <img src={icon9} alt="Icon" />
              <h3>Customizable AI features</h3>
              <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ProductPage;
